import ColorPerFeatureStyleSettingsModule from "./colorPerFeatureStyleSettingsModule";
import ConditionalStyleSettingsModule from "./conditionalStyleSettingsModule";
import ManageTerritoryBaseFeatureStyleSettingsModule from "./manageTerritoryBaseFeatureStyleSettingsModule";
import PointStyleSettingsModule from "./pointStyleSettingsModule";
import PolygonStyleSettingsModule from "./polygonStyleSettingsModule";
import SchedulePointStyleSettingsModule from "./schedulePointStyleSettingsModule";
import TerritoryPointStyleSettingsModule from "./territoryPointStyleSettingsModule";
import ThematicSettingsModule from "./thematicSettingsModule";

export default class StyleSettingsModule {
    ConditionalStyleSettings: ConditionalStyleSettingsModule;
    ColorPerFeatureSettings: ColorPerFeatureStyleSettingsModule;
    ManageTerritoryBaseFeatureStyleSettings: ManageTerritoryBaseFeatureStyleSettingsModule;
    PointStyleSettings: PointStyleSettingsModule;
    PolygonStyleSettings: PolygonStyleSettingsModule;
    SchedulePointStyleSettings: SchedulePointStyleSettingsModule;
    TerritoryPointStyleSettings: TerritoryPointStyleSettingsModule;

    constructor() {
        const thematicSettings = new ThematicSettingsModule();

        const conditionalStyleSettings = new ConditionalStyleSettingsModule();
        const colorPerFeatureStyleSettings = new ColorPerFeatureStyleSettingsModule();

        const pointStyleSettings = new PointStyleSettingsModule(thematicSettings, conditionalStyleSettings, colorPerFeatureStyleSettings);

        this.ConditionalStyleSettings = conditionalStyleSettings;
        this.ColorPerFeatureSettings = colorPerFeatureStyleSettings;
        this.ManageTerritoryBaseFeatureStyleSettings = new ManageTerritoryBaseFeatureStyleSettingsModule();
        this.PointStyleSettings = pointStyleSettings;
        this.PolygonStyleSettings = new PolygonStyleSettingsModule(this, thematicSettings);
        this.SchedulePointStyleSettings = new SchedulePointStyleSettingsModule(pointStyleSettings);
        this.TerritoryPointStyleSettings = new TerritoryPointStyleSettingsModule(pointStyleSettings);
    }

    /**
     * 
     * @param styleSettings 
     * @param territoryModel 
     * 
     * @returns 
     */
    getRequiredAttributes(styleSettings, territoryModel): string[] {
        const styleSettingsModule = this[styleSettings.$type];
        if (!styleSettingsModule) {
            throw new Error("Invalid styleSettings type: " + styleSettings.$type);
        }

        return styleSettingsModule.getRequiredAttributes(styleSettings, territoryModel);
    }

}
